<template>
  <div class="top_">
    <h1>20XX年 宇宙の旅</h1><br>
    <el-table class="data-table" :data="tableData" stripe>
      <el-table-column prop="url" label="画像">
        <template slot-scope="scope">
          <img :src="scope.row.url" width="50%" height="50%"/>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="日付" width="150"></el-table-column>
      <el-table-column prop="copyright" label="著作者" width="150"></el-table-column>
      <el-table-column prop="explanation" label="解説"></el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require('axios').create()
export default {
  name: 'top_',
  data () {
    return {
      tableData: []
    }
  },
  mounted () {
    this.updataTableData()
  },
  methods: {
    updataTableData: async function () {
      const response = await axios.get('/api/apod')
      this.tableData = response.data
    }
  }
}
</script>

<style scoped>
.data-table {
  width: 80%;
  margin: auto;
}
</style>
